var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini",
      "icon": "el-icon-delete",
      "round": ""
    },
    on: {
      "click": _vm.invalidateCache
    }
  }, [_vm._v("Invalidate Preset Cache")])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }